import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { SportsDataService, SportsColumnsService } from '../../../services';
import { Sport, SportsResult } from '../../../interfaces';
import { Editor } from 'primeng/editor';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EditorService } from '../../../../services/editor/editor.service';
import { DialogFilerComponent } from '../../filer/filer.component';

@Component({
  selector: 'app-sport-form',
  templateUrl: './sport-form.component.html',
  styleUrls: ['./sport-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class SportFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public sport: Sport = {};
  public sportForm: FormGroup = new FormGroup({});
  public sports: Sport[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  public Editor = ClassicEditor;
  private filerDialog: DynamicDialogRef = new DynamicDialogRef();

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private sportsDataService: SportsDataService,
    public sportsColumnsService: SportsColumnsService,
    public editorService: EditorService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'SportFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Sport - Edit');
        this.getSport(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.sport !== 'undefined') {
      this.sport = this.dynamicDialogConfig.data.sport;
    }
    if (typeof this.sport.id === 'undefined' || this.sport.id === null) {
      this.sport.id = null;
    }
    this.getSports();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'SportFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'SportFormComponent');
  }

  getSport(id: number): void {
    this.isLoading = true;
    this.sportsDataService.getSport(id).subscribe((response: Sport|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.sport = response;
        this.prepareFrom();
      }
    });
  }

  getSports(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.sports !== 'undefined' && this.dynamicDialogConfig.data.sports.length > 0) {
      this.sports = this.dynamicDialogConfig.data.sports;
      return;
    }
    this.sportsDataService.getSports(this.parameters).subscribe((response: SportsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.sports = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.sportForm = new FormGroup({
      id: new FormControl(this.sport.id, []),
      name: new FormControl(this.sport.name, [Validators.required, ]),
      nameAr: new FormControl(this.sport.nameAr, []),
      nameFr: new FormControl(this.sport.nameFr, []),
      picture: new FormControl(this.sport.picture, []),
      mobilePicture: new FormControl(this.sport.mobilePicture, []),
      title: new FormControl(this.sport.title, []),
      titleAr: new FormControl(this.sport.titleAr, []),
      titleFr: new FormControl(this.sport.titleFr, []),
      icon: new FormControl(this.sport.icon, []),
      color: new FormControl(this.sport.color, [Validators.required, ]),
      content: new FormControl(this.sport.content, []),
      contentAr: new FormControl(this.sport.contentAr, []),
      contentFr: new FormControl(this.sport.contentFr, []),
      status: new FormControl(this.sport.status, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/sports']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.sportForm.controls).forEach((field: any) => {
        const control = this.sportForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.sportForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.sport = this.sportForm.value;
    this.disableSubmit = true;
    console.log('sport', this.sport);
    if (typeof this.sport.id !== 'undefined' && this.sport.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.sportsDataService.updateSport(this.sport).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('SPORTUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('SPORTNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.sportsDataService.addSport(this.sport).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('SPORTCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('SPORTNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

  setColor(event: any) {
    const control = this.sportForm.get('color');
    if (control !== null) {
      control.setValue(event.value);
    }
  }

  openFilerDialog(field: string): void {
    let url = '';
    const control = this.sportForm.get(field);
    if (control !== null) {
      url = control.value;
    }
    this.filerDialog = this.dialogService.open(DialogFilerComponent, {
      header: '', // this.translate.instant('FILEMANAGER'),
      width: '90%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1500,
      data: {
        path: 'sports',
        field: field,
        url: url,
      },
    });
    this.filerDialog.onClose.subscribe((response: any) => {
      if (response && response.selected) {
        const control = this.sportForm.get(field);
        if (control !== null) {
          control.setValue(response.selected.webPath);
        }
      }
    });
  }

}

@Component({
  selector: 'app-sport-form',
  templateUrl: './sport-form.component.html',
  styleUrls: ['./sport-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogSportFormComponent extends SportFormComponent {
}

